import React from "react";
import { TableCell, Grid } from "@material-ui/core";
import { observer, inject } from "mobx-react";

import { Organisation } from "@src/Interfaces/Entity/Organisation";
import OrganisationEdit from "./OrganisationEdit/OrganisationEdit";
import { computed } from "mobx";
import { IValuesStore } from "@src/Stores/Values/types";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import { IManagementStore } from "@src/Stores/Management/types";
import { STTableRow } from "@src/Components/Ui/STTableRow";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";

interface IProps {
  organization: Organisation;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("auth", "values", "management")
@observer
class OrganisationTableItem extends React.Component<IProps> {
  @computed get isActive() {
    return this.props.organization.state === this.props.values.states.Active;
  }

  handleRemove = async () => {
    await this.props.management.removeOrganisation(this.props.organization.id);
  };

  render() {
    const organization: Organisation = this.props.organization;
    const canDelete = this.props.management.organisations.length > 1;
    return (
      <STTableRow hover isActive={this.isActive}>
        <TableCell component="th" scope="row" size="small">
          <STTableCellTypography>{organization.name}</STTableCellTypography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{organization.description}</STTableCellTypography>
        </TableCell>
        <TableCell align="right" size="small">
          <Grid container wrap="nowrap" justify="flex-end">
            {this.props.auth.user.location.primary && (
              <>
                <OrganisationEdit org={organization} />
                {canDelete && <EntityDelete onSubmit={this.handleRemove} />}
              </>
            )}
          </Grid>
        </TableCell>
      </STTableRow>
    );
  }
}

export default OrganisationTableItem;
